export type LanguageCode = 'no' | 'se' | 'en' | 'dk' | 'ar' | 'es';
export type SupportedLanguage = { code: LanguageCode; label: string; short: string };
export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: 'no', label: 'Norsk', short: 'NO' },
  { code: 'se', label: 'Svenska', short: 'SE' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'dk', label: 'Dansk', short: 'DK' },
  { code: 'es', label: 'Español', short: 'ES' },
  { code: 'ar', label: 'العربية', short: 'AR' },
];

const SUPPORTED_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

export const CULTURE_BY_CODE: Record<LanguageCode, string> = {
  no: 'nb-no',
  se: 'sv-se',
  en: 'en-us',
  dk: 'da-dk',
  es: 'es-es',
  ar: 'ar-ar',
};

export function toBackendCulture(code: string | null | undefined): string | undefined {
  if (!isSupportedLanguage(code)) return undefined;
  return CULTURE_BY_CODE[code.toLowerCase() as LanguageCode];
}

export function codeFromCulture(culture: string | null | undefined): LanguageCode | undefined {
  if (!culture) return undefined;
  const lc = culture.toLowerCase();
  const entry = (Object.entries(CULTURE_BY_CODE) as [LanguageCode, string][]).find(
    ([, mappedCulture]) => mappedCulture === lc
  );
  return entry?.[0];
}

export function isSupportedLanguage(code: string | null | undefined): code is LanguageCode {
  return !!code && (SUPPORTED_CODES as string[]).includes(code.toLowerCase());
}

export function mapBrowserLanguage(browserLang: string | undefined): LanguageCode | undefined {
  if (!browserLang) return undefined;
  const primary = browserLang.toLowerCase().split('-')[0];
  const map: Record<string, LanguageCode> = {
    nb: 'no', nn: 'no', no: 'no',
    sv: 'se', se: 'se',
    en: 'en',
    da: 'dk', dk: 'dk',
    es: 'es',
    ar: 'ar',
  };
  return map[primary] ?? (isSupportedLanguage(primary) ? (primary as LanguageCode) : undefined);
}
